import { DownloadOutlined } from '@ant-design/icons';
import { MILESTONE_TYPES } from '@rockalingua/shared/milestones/constants';

import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';
import Button from '@/shared/Button/Button';
import useMilestoneTracker from '@/v2/domains/Milestones/hooks/useMilestoneTracker.hook';

export default function GuideExtraButton({ activity }) {
  const plausibleContext = usePlausibleContext();
  const { trackMilestone } = useMilestoneTracker();

  if (!activity?.data?.guide) {
    return null;
  }

  return (
    <Button
      href={activity.data.guide}
      target="_blank"
      rel="noreferrer"
      icon={<DownloadOutlined />}
      onClick={() => {
        plausibleContext.actions.sendPlausibleEvent(
          'download_theme_teacher_guide',
          {
            activityId: activity.id,
            activityType: activity.type,
          }
        );
        trackMilestone(MILESTONE_TYPES.RESOURCE_PREPARED);
      }}
    >
      Download teacher guide
    </Button>
  );
}
